import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import isAllowedToReadAuditLogs from '@ion/api/audit-logs/isAllowedToReadAuditLogs';
import isAllowedToReadAuditLogDebugData from '@ion/api/audit-logs/isAllowedToReadAuditLogDebugData';

export default function useAuditLogAffordanceVisible() {
  const { auditLogModalMvpEnabled } = useFeatureEnabled(FEATURE_FLAGS.auditLogModalMvp);
  return auditLogModalMvpEnabled && isAllowedToReadAuditLogs() && isAllowedToReadAuditLogDebugData();
}
